import { Layout } from '@/components/Layout';
import { UnauthBanner } from '@/features/article-detail/components/UnauthBanner';
import { useUser } from '@/lib/auth';
import { ReactNode } from 'react';

type ArticleDetailLayoutProps = {
  children: ReactNode;
};

export const ArticleDetailLayout = ({ children }: ArticleDetailLayoutProps) => {
  const { data: user, isLoading: isUserLoading } = useUser();
  const redirectPath = `${window.location.pathname}${window.location.search}`;
  const shouldShowUnauthBanner = !isUserLoading && user == null;

  return (
    <Layout backgroundClassName="bg-slate-50">
      <div className="mx-auto flex w-full max-w-6xl flex-col p-3 sm:px-4 md:px-6">
        {shouldShowUnauthBanner && <UnauthBanner redirectPath={redirectPath} />}
        {children}
      </div>
    </Layout>
  );
};
